module.exports = __webpack_public_path__ + "static/media/favicon.948ec84d.ico";